import { ForwardedRef, forwardRef } from 'react'
import './styles.scss'
import { ICheckboxProps } from './types'

export const Checkbox = forwardRef(function Checkbox(
  {
    name,
    onChange,
    value,
    checked,
    id,
    className,
    disabled,
    ...props
  }: ICheckboxProps,
  checkboxRef: ForwardedRef<HTMLInputElement>
) {
  const getContainerClasses = () => {
    const classes = []

    if (disabled) classes.push('disabled')

    if (className) classes.push(className)

    return classes.join(' ')
  }

  return (
    <input
      ref={checkboxRef}
      name={name}
      id={id}
      type="checkbox"
      disabled={disabled ?? false}
      value={value}
      checked={checked}
      className={`itemCheckboxField ${getContainerClasses()}`}
      onChange={onChange}
      style={{
        width: props.width ?? 15,
        height: props.height ?? 15,
        accentColor: props.color || '#6204E5',
      }}
      {...props}
    />
  )
})
